export enum ChainId {
  MAINNET = 9736,
  TESTNET = 195,
  ZKCRO = 388,
  SONEIUM = 1868,
  DBK = 20240603,
  ABSTRACT = 2741,
  ABSTRACT_TESTNET = 11124,
  BERACHAIN = 80094,
  HYPERLIQUID = 999,
}

export const SUPPORTED_CHAIN_IDS = [ChainId.HYPERLIQUID, ChainId.BERACHAIN, ChainId.ABSTRACT, ChainId.DBK]

export const INITIAL_CHAIN_ID = ChainId.HYPERLIQUID

export const getInitialChainId = () => {
  const hash = window.location.hash
  const queryString = hash.split('?')[1]
  const params = new URLSearchParams(queryString || '')
  const chainId = params.get('chainId')
  return chainId ? parseInt(chainId) : INITIAL_CHAIN_ID
}

export const DEFAULT_CHAIN_ID: ChainId = getInitialChainId()

export const NETWORK_LABELS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: 'Bome',
  [ChainId.TESTNET]: 'Okb Testnet',
  [ChainId.ZKCRO]: 'zkEVM Cronos',
  [ChainId.SONEIUM]: 'Soneium',
  [ChainId.DBK]: 'DBK Chain',
  [ChainId.ABSTRACT]: 'Abstract',
  [ChainId.ABSTRACT_TESTNET]: 'Abstract Testnet',
  [ChainId.BERACHAIN]: 'Berachain',
  [ChainId.HYPERLIQUID]: 'Hyperliquid',
}

export const NETWORK_URLS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: 'https://rpc.bomechain.org',
  [ChainId.TESTNET]: 'https://testrpc.bomechain.org',
  [ChainId.ZKCRO]: 'https://mainnet.zkevm.cronos.org',
  [ChainId.SONEIUM]: 'https://nodes.sequence.app/soneium',
  [ChainId.DBK]: 'https://rpc.mainnet.dbkchain.io',
  [ChainId.ABSTRACT]: 'https://api.mainnet.abs.xyz',
  [ChainId.ABSTRACT_TESTNET]: 'https://abstract-testnet.public.blastapi.io',
  [ChainId.BERACHAIN]: 'https://rpc.berachain.com',
  [ChainId.HYPERLIQUID]: 'https://rpc.hyperliquid.xyz/evm',
}

export const EXPLORER_PREFIXES: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: 'bomescan.org',
  [ChainId.TESTNET]: 'www.okx.com/explorer/xlayer-test',
  [ChainId.ZKCRO]: 'explorer.zkevm.cronos.org',
  [ChainId.SONEIUM]: 'explorer.zkevm.cronos.org',
  [ChainId.DBK]: 'scan.dbkchain.io',
  [ChainId.ABSTRACT]: 'abscan.org',
  [ChainId.ABSTRACT_TESTNET]: 'sepolia.abscan.org',
  [ChainId.BERACHAIN]: 'berascan.com',
  [ChainId.BERACHAIN]: 'berascan.com',
  [ChainId.HYPERLIQUID]: 'hyperliquid.cloud.blockscout.com',
}

export const EXPLORER_URLS: { [chainId in ChainId]: string } = Object.fromEntries(
  Object.entries(EXPLORER_PREFIXES).map(([chainId, prefix]) => [
    chainId,
    prefix ? `https://${prefix}` : '', // Handle cases where prefix might be empty
  ])
) as { [chainId in ChainId]: string };

export const NATIVE_CURRENCY: { [chainId in ChainId]: { name: string; symbol: string; decimals: number } } = {
  [ChainId.MAINNET]: { name: 'BOME', symbol: 'BOME', decimals: 18 },
  [ChainId.TESTNET]: { name: 'OKB', symbol: 'OKB', decimals: 18 },
  [ChainId.ZKCRO]: { name: 'ZKCRO', symbol: 'ZKCRO', decimals: 18 },
  [ChainId.SONEIUM]: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  [ChainId.DBK]: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  [ChainId.ABSTRACT]: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  [ChainId.ABSTRACT_TESTNET]: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  [ChainId.BERACHAIN]: { name: 'Bera', symbol: 'BERA', decimals: 18 },
  [ChainId.HYPERLIQUID]: { name: 'Hype', symbol: 'HYPE', decimals: 18 },
}
